import { Locale } from '@enmon/commons';

export const DEFAULT_LOCALE = Locale.CS;

export const SUPPORTED_LOCALES: Locale[] = [Locale.CS, Locale.EN, Locale.SK, Locale.PL];
